import { validationSchemaWhyRevoke } from '../../PersonalDataApplicationSubmit/SubmitValidationSchemas.ts';
import { validationSchemaRevoke } from '../RevokeValidationSchemas.ts';
import { FormDataRevoke } from '../types.ts';

type ValidationSchema =
  | ReturnType<typeof validationSchemaRevoke>
  | ReturnType<typeof validationSchemaWhyRevoke>
  | null;

interface IFormConfig {
  validationSchema: ValidationSchema;
}

export const getRevokeFormConfig = (
  current: number,
  formData?: FormDataRevoke
): IFormConfig => {
  if (current === 1) {
    return {
      validationSchema: validationSchemaRevoke(formData || {}),
    };
  }

  if (current === 3) {
    return {
      validationSchema: validationSchemaWhyRevoke(),
    };
  }

  return {
    validationSchema: null,
  };
};

